<template>
  <div>
    <c-preloader v-if="isLoading" :isLoading="isLoading" bgcolor="rgba(3,3,3,0.9)"/>
    <c-nav/>
    <router-view></router-view>
    <c-footer/>
    <c-notified-modal/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import cNav from '@/components/Nav.vue'
import cPreloader from '@/components/Preloader.vue'
import cFooter from '@/components/Footer'
import cNotifiedModal from '@/components/NotifiedModal.vue'

export default {
  components: {
    cNav,
    cPreloader,
    cFooter,
    cNotifiedModal
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading,
      isFirstVisit: state => state.preloader.isFirstVisit
    })
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.$store.dispatch('actionPreloader', true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.$store.dispatch('actionPreloader', false)
      }, 2000)
    }
  }
}
</script>
